import type { Bonus } from '../types/offer';
export const bonuses: Bonus[] = [{
  number: '1',
  name: 'THE ARGENTINE FOOTBALL DICTIONARY',
  description: '১০০+ গুরুত্বপূর্ণ ধারণা সহজ ও সরাসরি কাজে লাগানোর মতো ভাষায় ব্যাখ্যা করা।',
  detail: 'সারাজীবন কাজে লাগবে এমন রেফারেন্স গাইড',
  cover: 'https://cdn.magicpatterns.com/uploads/fVtGKtTTYgKXnzhf3Qhrsv/BONO-1-BANGLADESH.png'
}, {
  number: '2',
  name: "THE CAPTAIN'S WORKBOOK",
  description: 'প্রতিটি ধারণা সাথে সাথেই প্রয়োগ করার ইন্টারঅ্যাকটিভ অনুশীলন।',
  detail: '৪০+ পৃষ্ঠার কার্যকরী ওয়ার্কশিট',
  cover: 'https://cdn.magicpatterns.com/uploads/4L7C3JuA1CRvXFozYjNsZR/BONO-2-BANGLADESH.png'
}, {
  number: '3',
  name: 'THE PRE-GAME FLOW',
  description: 'আধুনিক কাজ, ব্যবসা ও পড়াশোনার জন্য অ্যাডাপ্ট করা আর্জেন্টাইন সাকসেস রিচুয়াল।',
  detail: '১৫টি প্রমাণিত দৈনিক রুটিন, যা পারফরম্যান্স ৪০% বাড়ায়',
  cover: 'https://cdn.magicpatterns.com/uploads/9VmtKLJZK9VnHpbP85ec5R/BONO-3-BANGLADESH.png'
}, {
  number: '4',
  name: '50 SOUTHERN SECRETS',
  description: 'আর্জেন্টাইন কোচ, খেলোয়াড় ও উদ্যোক্তাদের সরাসরি উক্তি ও গল্প।',
  detail: 'বাংলাদেশের বাস্তবতায় প্রয়োগ করা প্রজ্ঞা',
  cover: 'https://cdn.magicpatterns.com/uploads/iRwfEM3YRaw7caKmptBx2A/BONO-4-BANGLADESH.png'
}, {
  number: '5',
  name: 'THE NEGOTIATION CRIOLLA',
  description: 'আর্জেন্টিনার শীর্ষ ১% পেশাদারদের ব্যবহৃত নেগোশিয়েশন ফ্রেমওয়ার্ক।',
  detail: 'বেতন আলোচনা, ক্লায়েন্ট ডিল বা জীবনের বড় সিদ্ধান্তে ব্যবহার করুন',
  cover: 'https://cdn.magicpatterns.com/uploads/6ff7hPzZKjq2fzNfHnDXB6/BONO-5-BANGHADESH.png'
}];
